<template>
  <Products :listTitle="listTitle" :content="content"/>
</template>

<script>
export default {
  data () {
    return {
      listTitle: '实验室管理系统',
      content: '<div style="font-size:16px;text-indent:2em;">dpiInfolab 是一套由实验室材料、仪器设备、日常办公等管理系统的集成系统</div><br /><br /><div style="font-size:16px;text-indent:2em;padding-top:10px;">采用授权管理，具备统一身份验证后台，提供用户管理，权限管理，仪器设备管理及计费，门禁管理，实验材料管理等功能。</div><div style="font-size:16px;text-indent:2em;padding-top:10px;">系统可扩展，提供数据对接接口，并对数据设有权限保护和备份保护</div><img src="../products/微信图片_20201127103012.png" style="width:700px;height:300px;margin:10px 30px;">'
    }
  }
}
</script>
